import { MultimediaUploadResponse } from '../../../@types/multimedia-types'
import { Attachment, AttachmentType } from '../../../@types/types'

export const multimediaToApp = ({
  id,
  url,
  bucketName,
  contentType,
  document,
  picture,
  source,
  title,
  floorplan,
  size,
}: MultimediaUploadResponse): Attachment => ({
  id,
  url,
  bucketName,
  contentType,
  document,
  picture,
  source,
  title,
  size,
  floorplan,
  type: picture ? AttachmentType.PICTURE : AttachmentType.DOCUMENT,
})
